/* eslint-disable react/no-unknown-property */
import React, { useState, useContext } from "react";
//Packages
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
//T&C Forms
import TermsAndConditions from "./common/termsAndConditions";
import PrivacyPolicy from "./common/privacyPolicy";
import { BusinessContextConsumer } from "./BusinessContext.js";

const Footer = () => {
  const [privacyModalOpen, setPrivacyModalOpen] = useState(false);
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  const context = useContext(BusinessContextConsumer);
  const { brandColour, generalTheme } = context;
  let textClass;
  if (generalTheme === "dark") {
    textClass = "text-light";
  } else {
    textClass = "text-dark";
  }
  return (
    <div>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'>
        <path
          fill={brandColour}
          fill-opacity='1'
          d='M0,288L48,266.7C96,245,192,203,288,197.3C384,192,480,224,576,245.3C672,267,768,277,864,282.7C960,288,1056,288,1152,282.7C1248,277,1344,267,1392,261.3L1440,256L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z'
        ></path>
      </svg>
      <footer className='footer' style={{ backgroundColor: brandColour }}>
        <Container>
          <Row className='pt-5'>
            <Col sm='6' className='d-flex justify-content-center'>
              <a className={`color: ${textClass}`} onClick={() => setTermsModalOpen(true)}>
                Terms &amp; Conditions
              </a>
            </Col>
            <Col sm='6' className='d-flex justify-content-center'>
              <a className={`color: ${textClass}`} onClick={() => setPrivacyModalOpen(true)}>
                Privacy Policy
              </a>
            </Col>
          </Row>
        </Container>
      </footer>
      {/*T&C MODAL*/}
      <Modal show={termsModalOpen} size='lg' onHide={() => setTermsModalOpen(false)} scrollable>
        <Modal.Header closeButton>
          <Modal.Title>Terms & Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TermsAndConditions />
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setTermsModalOpen(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/*PRIVACY POLICY MODAL*/}
      <Modal show={privacyModalOpen} size='lg' onHide={() => setPrivacyModalOpen(false)} scrollable>
        <Modal.Header closeButton>
          <Modal.Title>Privacy Policy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PrivacyPolicy />
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setPrivacyModalOpen(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Footer;
